import { MessagesPanel } from "@/components/MessagesPanel";

export default function ClientMessages() {
  return (
    <div className="space-y-6 lg:mt-0 mt-10" data-testid="client-messages">
      <header>
        <div className="overline">Coach</div>
        <h1 className="font-serif text-5xl mt-3">Messages</h1>
      </header>
      <MessagesPanel testid="client-msg-panel" />
    </div>
  );
}
